document.addEventListener("DOMContentLoaded", () => {
class InstanceSwiper extends HTMLElement {
    constructor() {
        super(), (this.handle = this.getAttribute("handle")), (this.swiperInitialized = !1);
    }
    static get observedAttributes() {
        return ["handle"];
    }
    init() {
        this.swiperInitialized ||
            ((this.swiperInitialized = !0),
            (this.options = this.setOptions()),
            (this.instance = new Swiper(".swiper--" + this.handle, this.options)),
            this.setInteractions());
    }
    connectedCallback() {
        Shopify.designMode
            ? (window.addEventListener("shopify:section:load", () => this.init()),
              window.addEventListener("shopify:section:select", () => this.init()),
              setTimeout(() => {
                  this.swiperInitialized || this.init();
              }, 100))
            : window.addEventListener("load", () => this.init());
    }
    disconnectedCallback() {
        this.instance && this.instance.destroy && this.instance.destroy();
    }
    setOptions() {
        return this.debug && console.log("setOptions"), (this._options = this.getOptionsAsJsonScripts()), this._options;
    }
    getOptionsAsJsonScripts() {
        this.debug && console.log("getOptionsAsJsonScripts");
        const t = this.querySelector(`script#swiper--${this.handle}--automated-options`),
            e = this.querySelector(`script#swiper--${this.handle}--overwrite-options`);
        let s = {};
        if (t && t.textContent)
            try {
                s = { ...s, ...JSON.parse(t.textContent) };
            } catch (e) {
                console.error("Error parsing JSON", e, t?.textContent);
            }
        if (e && e.textContent)
            try {
                s = { ...s, ...JSON.parse(e.textContent) };
            } catch (t) {
                console.error("Error parsing JSON", t, e?.textContent);
            }
        return s;
    }
    getThumbsInstance() {
        if (this.isThumbsActive) return document.querySelector(`[handle="${this.getAttribute("thumbs")}"]`)?.instance;
    }
    setInteractions() {
        this.debug && console.log("setInteractions");
    }
}
class InstanceSwiperProductThumbs extends InstanceSwiper {
    constructor() {
        super();
    }
    setOptions() {
        return super.setOptions(), this.setCenteredSlides(), this._options;
    }
    setCenteredSlides() {
        if ("product-thumbs" !== this.handle) return;
        this.debug && console.log("setCenteredSlides");
        this._options = {
            ...this._options,
            on: {
                ...(this._options.on || {}),
                afterInit: (t) => {
                    0 !== t.activeIndex && t.slideTo(0), this.debug && console.log("afterInit");
                    const e = t.wrapperEl,
                        s = new MutationObserver(function () {
                            e.hasAttribute("style") &&
                            e.style?.transform &&
                            "translate3d(0px, 0px, 0px)" !== e.style?.transform
                                ? ((e.style.transform = "translate3d(0px, 0px, 0px)"),
                                  this.debug && console.log("swiperWrapper observer removed styles!"))
                                : e.hasAttribute("style") &&
                                  e.style?.transform &&
                                  "translate3d(0px, 0px, 0px)" === e.style?.transform &&
                                  setTimeout(() => {
                                      e.hasAttribute("style") &&
                                          e.style?.transform &&
                                          "translate3d(0px, 0px, 0px)" === e.style?.transform &&
                                          (s.disconnect(),
                                          this.debug && console.log("swiperWrapper observer disconnect!"));
                                  }, 500);
                        });
                    s.observe(e, { attributes: !0 });
                    const i =
                            (this.querySelector(".swiper-slide").clientHeight + 16) *
                            this.querySelectorAll(".swiper-slide").length,
                        n = this.parentElement;
                    function o() {
                        n.offsetHeight > i ? (n.style.height = i - 16 + "px") : n.removeAttribute("style");
                    }
                    window.addEventListener("resize", o),
                        setTimeout(() => {
                            o();
                        }, 2500);
                },
            },
        };
    }
}
customElements.get("swiper-product-thumbs") ||
    customElements.define("swiper-product-thumbs", InstanceSwiperProductThumbs);
class InstanceSwiperProductGallery extends InstanceSwiper {
    constructor() {
        super(), (this.isThumbsActive = this.hasAttribute("thumbs")), (this.isZoomActive = this.hasAttribute("zoom"));
    }
    static get observedAttributes() {
        return ["thumbs", "zoom"];
    }
    setOptions() {
        return super.setOptions(), this.setThumbOptions(), this._options;
    }
    setThumbOptions() {
        if (!this.isThumbsActive) return;
        this.debug && console.log("setThumbOptions");
        const t = super.getThumbsInstance();
        this.debug && console.log("thumbsInstance", t), (this._options = { ...this._options, thumbs: { swiper: t } });
    }
    setInteractions() {
        this.isThumbsActive && this.setThumbsInteraction(),
            this.isZoomActive && this.photoSwipeLightboxInit(),
            this.instance.on("slideChange", (t) => {
                window.innerWidth < 750 &&
                    (t.pagination.update(), this.debug && console.log("Pagination updated manually on mobile."));
            }),
            this.instance.on("scroll", (t) => {
                clearTimeout(this.scrollTimeout),
                    (this.scrollTimeout = setTimeout(() => {
                        t.pagination.update(), this.debug && console.log("Pagination updated after scroll.");
                    }, 200));
            });
    }
    setThumbsInteraction() {
        if (!this.isThumbsActive || !this.instance) return;
        this.debug && console.log("setThumbsInteraction");
        const t = this.options.thumbs.swiper;
        this.instance.on("slideChangeTransitionStart", function (e) {
            const s = e.activeIndex,
                i = t.activeIndex;
            this.debug && console.log("slideChangeTransitionStart", s, i), s !== i && t.slideTo(s);
        });
    }
    photoSwipeLightboxInit() {
        const [t, e, s, i, n] = [
            this.offsetWidth,
            this.offsetHeight,
            document.querySelector("[data-close-icon]"),
            document.querySelector("[data-prev-icon]"),
            document.querySelector("[data-next-icon]"),
        ];
        function o() {
            return window.innerWidth < 750;
        }
        const r = new PhotoSwipeLightbox({
            gallery: ".photoswipe-wrapper",
            children: "a.product__gallery-toggle",
            mainClass: "pswp--product-media-gallery",
            loop: !1,
            showHideAnimationType: "zoom",
            initialZoomLevel: (t) => (o() ? t.vFill : t.fit),
            secondaryZoomLevel: (t) => (o() ? t.fit : 1),
            pswpModule: PhotoSwipe,
        });
        r.addFilter(
            "uiElement",
            (t, e) => (
                "close" === e.name
                    ? (t.innerHTML = s.innerHTML)
                    : "arrowPrev" === e.name
                      ? (t.innerHTML = i.innerHTML)
                      : "arrowNext" === e.name && (t.innerHTML = n.innerHTML),
                t
            )
        ),
            r.addFilter("itemData", (t, e) =>
                "html" === t.type && t.element ? { html: t.element.dataset.pswpHtml } : t
            ),
            r.init(),
            r.on("beforeOpen", () => {
                document.body.classList.add("oveflow-hidden");
                const t = this.querySelectorAll("video");
                Array.from(t).forEach((t) => {
                    t.play()
                        .then(() => {})
                        .catch((e) => {
                            t.pause();
                        });
                });
            }),
            r.on("closingAnimationStart", () => {
                document.body.classList.remove("oveflow-hidden");
            });
    }
    setActiveMedia(t) {
        const e = Array.from(this.querySelectorAll("[data-media-id]")).find((e) => Number(e.dataset.mediaId) === t);
        e &&
            this.instance &&
            "function" == typeof this.instance.slideTo &&
            "false" === this.dataset.hideOtherVariantsMedia &&
            this.instance.slideTo(Number(e.dataset.index));
    }
}
customElements.get("swiper-product-gallery") ||
    customElements.define("swiper-product-gallery", InstanceSwiperProductGallery);
class ProductMediaInfo extends HTMLElement {
    constructor() {
        super(),
            this.init(),
            window.addEventListener("resize", this.init.bind(this)),
            Shopify.designMode && window.addEventListener("shopify:section:load", this.init.bind(this));
    }
    init() {
        let t = document.querySelector(".main-product__media--slider").offsetWidth || 330;
        document.querySelector(".main-product__media--grid-item") &&
            window.innerWidth > 750 &&
            (t = document.querySelector(".main-product__media--grid-item").offsetWidth);
        const e = (t - 48) / 2,
            s = this.querySelector("p:last-child").offsetWidth,
            i = this.querySelector("p[aria-hidden]");
        s > e
            ? (this.classList.remove("animation-stopped"),
              (this.style.cssText = `--marquee-speed: ${(s / e) * 8}s`),
              (i.style.display = ""))
            : (this.classList.add("animation-stopped"), (this.style.cssText = ""), (i.style.display = "none"));
    }
}
customElements.get("product-media-info") || customElements.define("product-media-info", ProductMediaInfo);

});
